/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  root: {
    alignItems: 'center',
    '& .MuiFormControl-marginNormal': {
      marginTop: 0,
      marginBottom: Tokens.spacing['$sp-4']
    }
  },
  inputMargin: {
    marginBottom: Tokens.spacing['$sp-4']
  },
  loader: {
    textAlign: 'center',
    alignItems: 'center',
    padding: Tokens.spacing['$sp-3']
  },
  chip: {
    display: 'inline-block',
    marginRight: Tokens.spacing['$sp-3'],
    marginBottom: Tokens.spacing['$sp-2'],
  },
  no_chip: {
    margin: Tokens.spacing['$sp-2'],
    padding: Tokens.spacing['$sp-2'],
    backgroundColor: '#F0F2FA',
    color: theme.palette.text.primary,
    marginLeft: Tokens.spacing['$sp-0'],
    '& .MuiChip-deleteIcon': {
      width: Tokens.spacing['$sp-4'],
      height: Tokens.spacing['$sp-4'],
      color: theme.palette.text.secondary
    }
  },
  searchIcon: {
    padding: 0,
    color: theme.palette.text.secondary,
    cursor: 'initial'
  }
}));
